import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  VOID3gxj6tk5isa35 as VOID,
  CancellationException3b36o9qz53rgr as CancellationException,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ArrayList3it5z8td81qkl as ArrayList,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  RuntimeException1r3t0zl97011n as RuntimeException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  copyOfwy6h3t5vzqpl as copyOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  createThis2j2avj17cvnv2 as createThis,
  fill3lmv1pckd4inv as fill,
  Enum3alwj03lh1n41 as Enum,
  enumEntries20mr21zbe3az4 as enumEntries,
  constructCallableReference23y65rf941mch as constructCallableReference,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  lazy2hsh8ze7j6ikd as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  shiftRightUnsigned1kzopyqvwpisb as shiftRightUnsigned,
  convertToIntofdoxh9bstof as convertToInt,
  fromInt1lka3ktyu79a4 as fromInt,
  Long2qws0ah9gnpki as Long,
  bitwiseAnd2g7wmsfd45l12 as bitwiseAnd,
  shiftLeft1ck77p6vapyra as shiftLeft,
  bitwiseOr1ita6dahwp8zb as bitwiseOr,
  KProperty02ce7r476m8633 as KProperty0,
  printStackTrace18lnx7a39cni as printStackTrace,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  to2cs3ny02qtbcb as to,
  isArray1hxjqtqy632bc as isArray,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimStart1mkod6gyztuyy as trimStart,
  split2bvyvnrlcifjv as split,
  getOrNull1go7ef9ldk0df as getOrNull,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class NativeImageRef {}
class Cancellable {}
class CloseableCancellable {}
function cancel(e) {
  return this.f7();
}
class Companion {}
class CancellableGroup {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.tay_1 = ArrayList.p2();
  }
  uay(c) {
    var tmp0 = this.tay_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = cancellable(c);
    tmp0.d2(element);
  }
  f7() {
    this.say(CancellationException.i());
  }
  say(e) {
    cancel_1(this.tay_1, e);
  }
}
class sam$korlibs_io_lang_Cancellable$0 {
  constructor(function_0) {
    this.vay_1 = function_0;
  }
  say(e) {
    return this.vay_1(e);
  }
  p5() {
    return this.vay_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Cancellable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class AutoCloseable$1 {
  constructor($block) {
    this.way_1 = $block;
  }
  f7() {
    return this.way_1();
  }
}
class Companion_0 {
  wi(key) {
    var tmp1_safe_receiver = customEnvironments;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = key.toUpperCase();
      tmp = tmp1_safe_receiver.w4(tmp$ret$0);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = Companion_getInstance_4().zay();
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = key.toUpperCase();
      tmp_0 = tmp_1.w4(tmp$ret$2);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
}
class MalformedInputException extends Exception {
  constructor(msg) {
    return new.target.laz(msg);
  }
  static laz(msg) {
    var $this = this.c6(msg);
    captureStack($this, $this.kaz_1);
    return $this;
  }
}
class OutOfBoundsException extends Exception {
  constructor(index, str) {
    return new.target.oaz(index, str);
  }
  static oaz(index, str) {
    index = index === VOID ? -1 : index;
    str = str === VOID ? 'Out Of Bounds' : str;
    var $this = this.c6(str);
    captureStack($this, $this.naz_1);
    return $this;
  }
}
class InvalidOperationException extends Exception {
  constructor(str) {
    return new.target.caz(str);
  }
  static caz(str) {
    str = str === VOID ? 'Invalid Operation' : str;
    var $this = this.c6(str);
    captureStack($this, $this.baz_1);
    return $this;
  }
}
class UnreachableException extends Exception {
  constructor(str) {
    return new.target.faz(str);
  }
  static faz(str) {
    str = str === VOID ? 'Unreachable' : str;
    var $this = this.c6(str);
    captureStack($this, $this.eaz_1);
    return $this;
  }
}
class ReservedException extends Exception {
  constructor(str) {
    return new.target.iaz(str);
  }
  static iaz(str) {
    str = str === VOID ? 'Reserved' : str;
    var $this = this.c6(str);
    captureStack($this, $this.haz_1);
    return $this;
  }
}
class ByteArrayBuilder {
  constructor(data, size, allowGrow) {
    return new.target.saz(data, size, allowGrow);
  }
  static saz(data, size, allowGrow) {
    size = size === VOID ? data.length : size;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    var $this = createThis(this);
    $this.paz_1 = data;
    $this.qaz_1 = allowGrow;
    $this.raz_1 = size;
    return $this;
  }
  static taz(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.saz(new Int8Array(initialCapacity), 0);
  }
  aa2(value) {
    var oldPosition = this.raz_1;
    var newPosition = value;
    ensure(this, newPosition);
    this.raz_1 = newPosition;
    if (newPosition > oldPosition) {
      fill(this.paz_1, 0, oldPosition, newPosition);
    }
  }
  s2() {
    return this.raz_1;
  }
  uaz(array, offset, len) {
    ensureCount(this, len);
    arraycopy(this, array, offset, this.paz_1, this.raz_1, len);
    this.raz_1 = this.raz_1 + len | 0;
  }
  vaz(array, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? array.length - offset | 0 : len;
    var tmp;
    if ($super === VOID) {
      this.uaz(array, offset, len);
      tmp = Unit_instance;
    } else {
      tmp = $super.uaz.call(this, array, offset, len);
    }
    return tmp;
  }
  waz(v) {
    ensure(this, this.raz_1 + 1 | 0);
    var tmp = this.paz_1;
    var _unary__edvuaz = this.raz_1;
    this.raz_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v;
  }
  xaz() {
    return copyOf(this.paz_1, this.raz_1);
  }
}
class Companion_1 {
  yaz() {
    return get_currentArch();
  }
}
class Arch extends Enum {
  constructor(name, ordinal, bits, isArm, isX86OrX64, isMips, isWasm, isPowerPC) {
    isArm = isArm === VOID ? false : isArm;
    isX86OrX64 = isX86OrX64 === VOID ? false : isX86OrX64;
    isMips = isMips === VOID ? false : isMips;
    isWasm = isWasm === VOID ? false : isWasm;
    isPowerPC = isPowerPC === VOID ? false : isPowerPC;
    super(name, ordinal);
    this.bb0_1 = bits;
    this.cb0_1 = isArm;
    this.db0_1 = isX86OrX64;
    this.eb0_1 = isMips;
    this.fb0_1 = isWasm;
    this.gb0_1 = isPowerPC;
  }
  hb0() {
    return this.bb0_1 === 32;
  }
  ib0() {
    return this.bb0_1 === 64;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    this.jb0_1 = get_currentIsLittleEndian() ? Endian_LITTLE_ENDIAN_getInstance() : Endian_BIG_ENDIAN_getInstance();
  }
}
class Endian extends Enum {
  mb0() {
    return this.equals(Endian_LITTLE_ENDIAN_getInstance());
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.nb0_1 = get_entries();
  }
  yaz() {
    return get_currentOs();
  }
}
class Os extends Enum {
  qb0() {
    return this.equals(Os_WINDOWS_getInstance());
  }
  rb0() {
    return this.equals(Os_LINUX_getInstance());
  }
  sb0() {
    return this.equals(Os_MACOSX_getInstance());
  }
  tb0() {
    return this.equals(Os_IOS_getInstance());
  }
  ub0() {
    return this.equals(Os_TVOS_getInstance());
  }
  vb0() {
    return this.tb0() || this.ub0();
  }
  wb0() {
    return this.sb0() || this.vb0();
  }
}
class Platform {}
function get_isWindows() {
  return this.zb0().qb0();
}
function get_isLinux() {
  return this.zb0().rb0();
}
function get_isMac() {
  return this.zb0().sb0();
}
function get_isJs() {
  return this.ab1().cb1();
}
function get_isNative() {
  return this.ab1().db1();
}
function get_isWasm() {
  return this.ab1().eb1();
}
function get_isJsOrWasm() {
  return this.cb1() || this.eb1();
}
function get_isJsNodeJs() {
  return this.bb1() === 'js-node' || this.bb1() === 'wasm-node';
}
function get_isJsDenoJs() {
  return this.bb1() === 'js-deno' || this.bb1() === 'wasm-deno';
}
function get_isJsBrowser() {
  return this.bb1() === 'js-web' || this.bb1() === 'wasm-web';
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    tmp.xay_1 = lazy(Platform$Companion$envs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.yay_1 = lazy(Platform$Companion$envsUC$delegate$lambda);
  }
  yb0() {
    return Companion_instance_1.yaz();
  }
  zb0() {
    return Companion_getInstance_3().yaz();
  }
  ab1() {
    return Companion_instance_5.yaz();
  }
  bb1() {
    return get_currentRawPlatformName();
  }
  xb0() {
    var tmp0 = this.xay_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('envs', 1, tmp, Platform$Companion$_get_envs_$ref_ppeh37(), null);
    return tmp0.k3();
  }
  zay() {
    var tmp0 = this.yay_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('envsUC', 1, tmp, Platform$Companion$_get_envsUC_$ref_by0yzz(), null);
    return tmp0.k3();
  }
}
class Companion_5 {
  yaz() {
    return get_currentRuntime();
  }
}
class Runtime extends Enum {
  cb1() {
    return this.equals(Runtime_JS_getInstance());
  }
  lb1() {
    return this.equals(Runtime_JVM_getInstance());
  }
  db1() {
    return this.equals(Runtime_NATIVE_getInstance());
  }
  eb1() {
    return this.equals(Runtime_WASM_getInstance());
  }
}
class IOException extends Exception {
  static sb1(msg) {
    var $this = this.c6(msg);
    captureStack($this, $this.rb1_1);
    return $this;
  }
}
class FileNotFoundException extends IOException {
  constructor(msg) {
    return new.target.pb1(msg);
  }
  static pb1(msg) {
    var $this = this.sb1(msg);
    captureStack($this, $this.ob1_1);
    return $this;
  }
}
class EOFException extends IOException {
  constructor(msg) {
    return new.target.wb1(msg);
  }
  static wb1(msg) {
    var $this = this.sb1(msg);
    captureStack($this, $this.vb1_1);
    return $this;
  }
}
class Companion_6 {}
class DenoPointer {
  constructor(rawPointer) {
    this.xb1_1 = rawPointer;
  }
  toString() {
    return 'DenoPointer(rawPointer=' + toString(this.xb1_1) + ')';
  }
  hashCode() {
    return hashCode(this.xb1_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DenoPointer))
      return false;
    var tmp0_other_with_cast = other instanceof DenoPointer ? other : THROW_CCE();
    if (!equals(this.xb1_1, tmp0_other_with_cast.xb1_1))
      return false;
    return true;
  }
}
//endregion
function cancel_0(_this__u8e3s4) {
  return _this__u8e3s4.say(CancellationException.n(''));
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function Closeable(block) {
  return AutoCloseable_0(block);
}
function cancellable(_this__u8e3s4) {
  var tmp = cancellable$lambda(_this__u8e3s4);
  return new sam$korlibs_io_lang_Cancellable$0(tmp);
}
function cancel_1(_this__u8e3s4, e) {
  e = e === VOID ? CancellationException.n('') : e;
  // Inline function 'kotlin.run' call
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var c = _iterator__ex2g4s.r1();
    c.say(e);
  }
  return Unit_instance;
}
function AutoCloseable_0(block) {
  return new AutoCloseable$1(block);
}
function cancellable$lambda($this_cancellable) {
  return (it) => {
    $this_cancellable.f7();
    return Unit_instance;
  };
}
var customEnvironments;
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function invalidOp(msg) {
  throw InvalidOperationException.caz(msg);
}
function get_unreachable() {
  throw UnreachableException.faz();
}
function get_invalidOp() {
  throw InvalidOperationException.caz();
}
function unsupported(msg) {
  msg = msg === VOID ? 'unsupported' : msg;
  throw UnsupportedOperationException.a1(msg);
}
function reserved(msg) {
  throw ReservedException.iaz(msg);
}
function get_reserved() {
  throw ReservedException.iaz();
}
function ensure($this, expected) {
  if ($this.paz_1.length < expected) {
    if (!$this.qaz_1)
      throw RuntimeException.xb('ByteArrayBuffer configured to not grow!');
    var newSize = imul($this.paz_1.length + 7 | 0, 5);
    var realNewSize = newSize < 0 ? 1073741823 : newSize;
    if (newSize < 0 && expected > realNewSize) {
      // Inline function 'kotlin.error' call
      var message = "ByteArrayBuffer can't grow that much";
      throw IllegalStateException.o(toString(message));
    }
    var tmp = $this;
    var tmp_0 = $this.paz_1;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$1 = Math.max(expected, realNewSize);
    tmp.paz_1 = copyOf(tmp_0, tmp$ret$1);
  }
}
function ensureCount($this, count) {
  ensure($this, $this.raz_1 + count | 0);
}
function arraycopy($this, src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
var Arch_UNKNOWN_instance;
var Arch_X86_instance;
var Arch_X64_instance;
var Arch_ARM32_instance;
var Arch_ARM64_instance;
var Arch_MIPS32_instance;
var Arch_MIPSEL32_instance;
var Arch_MIPS64_instance;
var Arch_MIPSEL64_instance;
var Arch_WASM32_instance;
var Arch_POWERPC64_instance;
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var Arch_entriesInitialized;
function Arch_initEntries() {
  if (Arch_entriesInitialized)
    return Unit_instance;
  Arch_entriesInitialized = true;
  Arch_UNKNOWN_instance = new Arch('UNKNOWN', 0, -1);
  Arch_X86_instance = new Arch('X86', 1, 32, VOID, true);
  Arch_X64_instance = new Arch('X64', 2, 64, VOID, true);
  Arch_ARM32_instance = new Arch('ARM32', 3, 32, true);
  Arch_ARM64_instance = new Arch('ARM64', 4, 64, true);
  Arch_MIPS32_instance = new Arch('MIPS32', 5, 32, VOID, VOID, true);
  Arch_MIPSEL32_instance = new Arch('MIPSEL32', 6, 32, VOID, VOID, true);
  Arch_MIPS64_instance = new Arch('MIPS64', 7, 64, VOID, VOID, true);
  Arch_MIPSEL64_instance = new Arch('MIPSEL64', 8, 64, VOID, VOID, true);
  Arch_WASM32_instance = new Arch('WASM32', 9, 32, VOID, VOID, VOID, true);
  Arch_POWERPC64_instance = new Arch('POWERPC64', 10, 64, VOID, VOID, VOID, VOID, true);
}
function Arch_UNKNOWN_getInstance() {
  Arch_initEntries();
  return Arch_UNKNOWN_instance;
}
var Endian_LITTLE_ENDIAN_instance;
var Endian_BIG_ENDIAN_instance;
var Companion_instance_2;
function Companion_getInstance_2() {
  Endian_initEntries();
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var Endian_entriesInitialized;
function Endian_initEntries() {
  if (Endian_entriesInitialized)
    return Unit_instance;
  Endian_entriesInitialized = true;
  Endian_LITTLE_ENDIAN_instance = new Endian('LITTLE_ENDIAN', 0);
  Endian_BIG_ENDIAN_instance = new Endian('BIG_ENDIAN', 1);
  Companion_getInstance_2();
}
function Endian_LITTLE_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_LITTLE_ENDIAN_instance;
}
function Endian_BIG_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_BIG_ENDIAN_instance;
}
var Os_UNKNOWN_instance;
var Os_WASM_instance;
var Os_LINUX_instance;
var Os_WINDOWS_instance;
var Os_ANDROID_instance;
var Os_MACOSX_instance;
var Os_IOS_instance;
var Os_TVOS_instance;
var Os_WATCHOS_instance;
var Companion_instance_3;
function Companion_getInstance_3() {
  Os_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [Os_UNKNOWN_getInstance(), Os_WASM_getInstance(), Os_LINUX_getInstance(), Os_WINDOWS_getInstance(), Os_ANDROID_getInstance(), Os_MACOSX_getInstance(), Os_IOS_getInstance(), Os_TVOS_getInstance(), Os_WATCHOS_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Os_entriesInitialized;
function Os_initEntries() {
  if (Os_entriesInitialized)
    return Unit_instance;
  Os_entriesInitialized = true;
  Os_UNKNOWN_instance = new Os('UNKNOWN', 0);
  Os_WASM_instance = new Os('WASM', 1);
  Os_LINUX_instance = new Os('LINUX', 2);
  Os_WINDOWS_instance = new Os('WINDOWS', 3);
  Os_ANDROID_instance = new Os('ANDROID', 4);
  Os_MACOSX_instance = new Os('MACOSX', 5);
  Os_IOS_instance = new Os('IOS', 6);
  Os_TVOS_instance = new Os('TVOS', 7);
  Os_WATCHOS_instance = new Os('WATCHOS', 8);
  Companion_getInstance_3();
}
var $ENTRIES;
function Os_UNKNOWN_getInstance() {
  Os_initEntries();
  return Os_UNKNOWN_instance;
}
function Os_WASM_getInstance() {
  Os_initEntries();
  return Os_WASM_instance;
}
function Os_LINUX_getInstance() {
  Os_initEntries();
  return Os_LINUX_instance;
}
function Os_WINDOWS_getInstance() {
  Os_initEntries();
  return Os_WINDOWS_instance;
}
function Os_ANDROID_getInstance() {
  Os_initEntries();
  return Os_ANDROID_instance;
}
function Os_MACOSX_getInstance() {
  Os_initEntries();
  return Os_MACOSX_instance;
}
function Os_IOS_getInstance() {
  Os_initEntries();
  return Os_IOS_instance;
}
function Os_TVOS_getInstance() {
  Os_initEntries();
  return Os_TVOS_instance;
}
function Os_WATCHOS_getInstance() {
  Os_initEntries();
  return Os_WATCHOS_instance;
}
function Platform$Companion$envs$delegate$lambda() {
  return get_envs();
}
function Platform$Companion$_get_envs_$ref_ppeh37() {
  return constructCallableReference((p0) => p0.xb0(), 1, 0, 74);
}
function Platform$Companion$envsUC$delegate$lambda() {
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = Companion_getInstance_4().xb0();
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap.cd(mapCapacity(this_0.s2()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = element.j3().toUpperCase();
    var tmp$ret$6 = element.k3();
    destination.b5(tmp, tmp$ret$6);
  }
  return destination;
}
function Platform$Companion$_get_envsUC_$ref_by0yzz() {
  return constructCallableReference((p0) => p0.zay(), 1, 0, 75);
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Runtime_JS_instance;
var Runtime_JVM_instance;
var Runtime_ANDROID_instance;
var Runtime_NATIVE_instance;
var Runtime_WASM_instance;
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var Runtime_entriesInitialized;
function Runtime_initEntries() {
  if (Runtime_entriesInitialized)
    return Unit_instance;
  Runtime_entriesInitialized = true;
  Runtime_JS_instance = new Runtime('JS', 0);
  Runtime_JVM_instance = new Runtime('JVM', 1);
  Runtime_ANDROID_instance = new Runtime('ANDROID', 2);
  Runtime_NATIVE_instance = new Runtime('NATIVE', 3);
  Runtime_WASM_instance = new Runtime('WASM', 4);
}
function Runtime_JS_getInstance() {
  Runtime_initEntries();
  return Runtime_JS_instance;
}
function Runtime_JVM_getInstance() {
  Runtime_initEntries();
  return Runtime_JVM_instance;
}
function Runtime_NATIVE_getInstance() {
  Runtime_initEntries();
  return Runtime_NATIVE_instance;
}
function Runtime_WASM_getInstance() {
  Runtime_initEntries();
  return Runtime_WASM_instance;
}
function get_portableSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.j1();
  return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function get_Deno_isDeno() {
  // Inline function 'kotlin.js.unsafeCast' call
  return 'Deno' in window;
}
function get_pointer(_this__u8e3s4) {
  return new DenoPointer(_this__u8e3s4);
}
function toArray(_this__u8e3s4) {
  return Array.from(_this__u8e3s4);
}
function jsObject(pairs) {
  var out = jsEmptyObj();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var pair = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    out[pair.pm_1] = pair.qm_1;
  }
  return out;
}
function jsNew(clazz) {
  return (new clazz())();
}
function jsEmptyObj() {
  return {};
}
function toJsBigInt(_this__u8e3s4) {
  var bi64 = new BigInt64Array(1);
  var i32 = new Int32Array(bi64.buffer);
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  i32[0] = convertToInt(shiftRightUnsigned(_this__u8e3s4, 0));
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  i32[1] = convertToInt(shiftRightUnsigned(_this__u8e3s4, 32));
  return get(bi64, 0);
}
function toLong(_this__u8e3s4) {
  var bi64 = new BigInt64Array(1);
  var i32 = new Int32Array(bi64.buffer);
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = i32[0];
  var low = bitwiseAnd(fromInt(tmp$ret$0), new Long(-1, 0));
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = i32[1];
  var high = bitwiseAnd(fromInt(tmp$ret$2), new Long(-1, 0));
  return bitwiseOr(low, shiftLeft(high, 32));
}
function get(_this__u8e3s4, index) {
  // Inline function 'kotlin.js.asDynamic' call
  return BigInt(_this__u8e3s4[index]);
}
function get_isDenoJs() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp0 = isDenoJs$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isDenoJs', 0, tmp, _get_isDenoJs_$ref_1x6n2z(), null);
  return tmp0.k3();
}
var isDenoJs$delegate;
function get_isWeb() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp0 = isWeb$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isWeb', 0, tmp, _get_isWeb_$ref_nuw7ue(), null);
  return tmp0.k3();
}
var isWeb$delegate;
function get_isWorker() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp0 = isWorker$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isWorker', 0, tmp, _get_isWorker_$ref_bx337y(), null);
  return tmp0.k3();
}
var isWorker$delegate;
function get_isNodeJs() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp0 = isNodeJs$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isNodeJs', 0, tmp, _get_isNodeJs_$ref_y8oeqt(), null);
  return tmp0.k3();
}
var isNodeJs$delegate;
function get_currentArch() {
  _init_properties_Current_js_kt__w11d1e();
  return currentArch;
}
var currentArch;
function get_currentRuntime() {
  _init_properties_Current_js_kt__w11d1e();
  return currentRuntime;
}
var currentRuntime;
var currentIsDebug;
function get_currentIsLittleEndian() {
  _init_properties_Current_js_kt__w11d1e();
  return currentIsLittleEndian;
}
var currentIsLittleEndian;
var multithreadedSharedHeap;
function get_currentRawPlatformName() {
  _init_properties_Current_js_kt__w11d1e();
  return currentRawPlatformName;
}
var currentRawPlatformName;
var currentRawOsName;
function get_envs() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp0 = envs$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('envs', 0, tmp, _get_envs_$ref_pjq2lo(), null);
  return tmp0.k3();
}
var envs$delegate;
function get_jsGlobalThis() {
  _init_properties_Current_js_kt__w11d1e();
  return globalThis;
}
function get_currentOs() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp;
  if (get_isDenoJs()) {
    switch (Deno.build.os) {
      case 'darwin':
        tmp = Os_MACOSX_getInstance();
        break;
      case 'linux':
        tmp = Os_LINUX_getInstance();
        break;
      case 'windows':
        tmp = Os_WINDOWS_getInstance();
        break;
      default:
        tmp = Os_UNKNOWN_getInstance();
        break;
    }
  } else {
    tmp = Os_UNKNOWN_getInstance();
  }
  return tmp;
}
function get_isShell() {
  _init_properties_Current_js_kt__w11d1e();
  return !get_isWeb() && !get_isNodeJs() && !get_isWorker();
}
function get_process() {
  _init_properties_Current_js_kt__w11d1e();
  if (typeof process === 'undefined') {
    try {
      // Inline function 'kotlin.error' call
      var message = "Not in NodeJS. Can't access process";
      throw IllegalStateException.o(toString(message));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        throw e;
      } else {
        throw $p;
      }
    }
  }
  return process;
}
function jsObjectToMap(obj) {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = jsObjectKeysArray(obj);
  var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap.cd(capacity);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element, obj[element]);
    destination.b5(pair.pm_1, pair.qm_1);
  }
  return destination;
}
function jsObjectKeysArray(obj) {
  _init_properties_Current_js_kt__w11d1e();
  var tmp = jsToArray(jsObjectKeys(obj));
  return isArray(tmp) ? tmp : THROW_CCE();
}
function jsToArray(obj) {
  _init_properties_Current_js_kt__w11d1e();
  var tmp = 0;
  var tmp_0 = obj.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = Array(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = obj[tmp_2];
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function jsObjectKeys(obj) {
  _init_properties_Current_js_kt__w11d1e();
  return Object.keys(obj);
}
function isDenoJs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync !== undefined;
}
function _get_isDenoJs_$ref_1x6n2z() {
  return constructCallableReference(() => get_isDenoJs(), 0, 0, 76);
}
function isWeb$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function _get_isWeb_$ref_nuw7ue() {
  return constructCallableReference(() => get_isWeb(), 0, 0, 77);
}
function isWorker$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function _get_isWorker_$ref_bx337y() {
  return constructCallableReference(() => get_isWorker(), 0, 0, 78);
}
function isNodeJs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function _get_isNodeJs_$ref_y8oeqt() {
  return constructCallableReference(() => get_isNodeJs(), 0, 0, 79);
}
function envs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp;
  if (get_isDenoJs()) {
    tmp = jsObjectToMap(Deno.env.toObject());
  } else if (get_isNodeJs()) {
    tmp = jsObjectToMap(get_process().env);
  } else {
    // Inline function 'kotlin.also' call
    var this_0 = LinkedHashMap.m7();
    var tmp1_safe_receiver = document.location;
    var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.search;
    var hash = trimStart(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, charArrayOf([_Char___init__impl__6a9atx(63)]));
    var _iterator__ex2g4s = split(hash, ['&']).p1();
    while (_iterator__ex2g4s.q1()) {
      var part = _iterator__ex2g4s.r1();
      var parts = split(part, ['=']);
      var key = decodeURIComponent(parts.u2(0));
      var tmp1_elvis_lhs = getOrNull(parts, 1);
      var value = decodeURIComponent(tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      this_0.b5(key, value);
    }
    tmp = this_0;
  }
  return tmp;
}
function _get_envs_$ref_pjq2lo() {
  return constructCallableReference(() => get_envs(), 0, 0, 80);
}
var properties_initialized_Current_js_kt_4h6d9c;
function _init_properties_Current_js_kt__w11d1e() {
  if (!properties_initialized_Current_js_kt_4h6d9c) {
    properties_initialized_Current_js_kt_4h6d9c = true;
    isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
    isWeb$delegate = lazy(isWeb$delegate$lambda);
    isWorker$delegate = lazy(isWorker$delegate$lambda);
    isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
    currentArch = Arch_UNKNOWN_getInstance();
    currentRuntime = Runtime_JS_getInstance();
    currentIsDebug = false;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [287454020];
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.js.asDynamic' call
    currentIsLittleEndian = (new Uint8Array((new Uint32Array(tmp$ret$0)).buffer))[0] === 68;
    multithreadedSharedHeap = false;
    currentRawPlatformName = get_isDenoJs() ? 'js-deno' : get_isWeb() ? 'js-web' : get_isNodeJs() ? 'js-node' : get_isWorker() ? 'js-worker' : get_isShell() ? 'js-shell' : 'js';
    var tmp;
    if (get_isDenoJs()) {
      tmp = 'deno';
    } else if (get_isWeb() || get_isWorker()) {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = navigator.userAgent;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = get_process().platform;
    }
    currentRawOsName = tmp;
    envs$delegate = lazy(envs$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForInterface(NativeImageRef, 'NativeImageRef');
initMetadataForInterface(Cancellable, 'Cancellable');
initMetadataForInterface(CloseableCancellable, 'CloseableCancellable', VOID, VOID, [AutoCloseable, Cancellable]);
initMetadataForCompanion(Companion);
initMetadataForClass(CancellableGroup, 'CancellableGroup', CancellableGroup, VOID, [CloseableCancellable]);
initMetadataForClass(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0', VOID, VOID, [Cancellable, FunctionAdapter]);
initMetadataForClass(AutoCloseable$1, VOID, VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(MalformedInputException, 'MalformedInputException');
initMetadataForClass(OutOfBoundsException, 'OutOfBoundsException', OutOfBoundsException.oaz);
initMetadataForClass(InvalidOperationException, 'InvalidOperationException', InvalidOperationException.caz);
initMetadataForClass(UnreachableException, 'UnreachableException', UnreachableException.faz);
initMetadataForClass(ReservedException, 'ReservedException', ReservedException.iaz);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', ByteArrayBuilder.taz);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Arch, 'Arch');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Endian, 'Endian');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Os, 'Os');
initMetadataForInterface(Platform, 'Platform');
protoOf(Companion_4).qb0 = get_isWindows;
protoOf(Companion_4).rb0 = get_isLinux;
protoOf(Companion_4).sb0 = get_isMac;
protoOf(Companion_4).cb1 = get_isJs;
protoOf(Companion_4).db1 = get_isNative;
protoOf(Companion_4).eb1 = get_isWasm;
protoOf(Companion_4).fb1 = get_isJsOrWasm;
protoOf(Companion_4).gb1 = get_isJsNodeJs;
protoOf(Companion_4).hb1 = get_isJsDenoJs;
protoOf(Companion_4).ib1 = get_isJsBrowser;
initMetadataForCompanion(Companion_4, VOID, [Platform]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Runtime, 'Runtime');
initMetadataForClass(IOException, 'IOException');
initMetadataForClass(FileNotFoundException, 'FileNotFoundException');
initMetadataForClass(EOFException, 'EOFException');
initMetadataForCompanion(Companion_6);
initMetadataForClass(DenoPointer, 'DenoPointer');
//endregion
//region block: init
Companion_instance = new Companion();
customEnvironments = null;
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
//endregion
//region block: exports
export {
  Companion_instance_0 as Companion_instanceubj3e1ju0kss,
  Companion_getInstance_3 as Companion_getInstancel0h9d9tr3c15,
  Companion_getInstance_4 as Companion_getInstance1ju3fwn4mt9wh,
  Endian_BIG_ENDIAN_getInstance as Endian_BIG_ENDIAN_getInstance3o2xiv864s15m,
  Endian_LITTLE_ENDIAN_getInstance as Endian_LITTLE_ENDIAN_getInstance43td1z4hn3ua,
  Os_UNKNOWN_getInstance as Os_UNKNOWN_getInstance3c2e0nugjslqw,
  NativeImageRef as NativeImageRefqizti6jm75,
  CancellableGroup as CancellableGroup3e8z70ga3djg,
  Cancellable as Cancellable3gmnln785cfrg,
  cancel as cancel1amaozv14ic7s,
  CloseableCancellable as CloseableCancellable3mxnqaxyfppmn,
  Closeable as Closeable2m9yv0b0gma2l,
  EOFException as EOFExceptiona2wwqnj55hh5,
  FileNotFoundException as FileNotFoundException2tz8ve019qipn,
  IOException as IOException33c9ezfvq1zr9,
  MalformedInputException as MalformedInputException12cxjt7zq8psv,
  OutOfBoundsException as OutOfBoundsException1k0x58dcca6fx,
  cancel_0 as cancel1n0qjc93h2v6w,
  get_invalidOp as get_invalidOp31x7cztl0dv9m,
  invalidOp as invalidOp1stebxh2m3n07,
  get_portableSimpleName as get_portableSimpleName6o7s8nc63i85,
  get_reserved as get_reserved2d9gxjta2y60d,
  reserved as reserved38luap2kxmc9d,
  get_unreachable as get_unreachable2fi7msfg0vgzd,
  unsupported as unsupported198cz39rr1ztw,
  DenoPointer as DenoPointerpb0vypijx63v,
  get_Deno_isDeno as get_Deno_isDeno1rvz34wr12yh3,
  jsNew as jsNewco39te1yl3up,
  jsObject as jsObjectr1r5ao37ef4f,
  get_pointer as get_pointerlkbwhoqlhapz,
  toArray as toArray1y3va21vj7n9x,
  toJsBigInt as toJsBigInt2lj477tra3oly,
  toLong as toLong12oqfsfu42e35,
  ByteArrayBuilder as ByteArrayBuilderyrflhqjz64ju,
  get_jsGlobalThis as get_jsGlobalThis3odmbn60utci,
};
//endregion
